import { ApiService } from '../ApiService';
import { APIKey } from '../../entities/APIKey';

export class APIKeyService {
  public static create(name: string): Promise<APIKey> {
    return ApiService.post<APIKey>(`/organization_settings/api_keys/`, {
      name,
    });
  }

  public static update(
    apiKeyId: number,
    name: string,
    status: string,
  ): Promise<void> {
    return ApiService.put<void>(`/organization_settings/api_keys/${apiKeyId}`, {
      name,
      status,
    });
  }
}
